exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rankBg[data-v-6642b73b]{background:url(" + require("../../dist/bg01.jpg") + ");width:100%;height:100%;background-size:15%}.rank_list[data-v-6642b73b]{background:url(" + require("../../dist/bg01.jpg") + ");background-size:15%;width:100%;overflow:hidden;padding-left:20px;box-sizing:border-box;position:absolute;top:129px}.rank_list li[data-v-6642b73b]{width:100%;overflow:hidden;border-bottom:1px solid #333;margin-bottom:18px}.rank_list li>div[data-v-6642b73b]{float:left;margin-bottom:14px;width:80px;height:70px;line-height:70px;color:#ccc;font-size:16px;margin-left:10px}.rank_list .text[data-v-6642b73b]{width:40%;margin-left:34px}.rank_list li img[data-v-6642b73b]{width:70px}.rank_list .icon[data-v-6642b73b]{width:12px;float:right;margin-right:22px;margin-left:0}.rank_list .icon img[data-v-6642b73b]{width:10px;margin-top:27px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-6642b73b","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/rank.vue
// module id = 51
// module chunks = 0